import { AssetType, ManualBrokerID } from 'config/consts';
import React from 'react';
import { useRouting } from 'hooks/useRouting';
import { formatNumber } from 'utils/formatter';
import { AssetTypesLabel } from 'components/features/utils/assetType';
import {
  AssetOrganizedPortfolioItemProps,
  isSimple,
} from './PortfolioStuffingAsset';
import { StopAggregate } from './AssetOrganizedPortfolioForeign';

const goto = (pushRouting: ReturnType<typeof useRouting>['pushRouting']) => (
  href: string | null
) => (): void => {
  if (href) pushRouting({ path: href }, true, window.scrollY);
};

export const DataFetching = ({
  className,
}: {
  className?: string;
}): React.ReactElement => {
  return (
    <div className={`flex flex-col ${className ?? ''}`}>
      <div className="form-error-note">
        <div className="icon-alert"></div>
        <div className="info-label">データ取得中です</div>
      </div>
    </div>
  );
};

export const AssetOrganizedPortfolioItem = ({
  assetTypeKey,
  brokerID,
  quantity,
  identifier,
  name,
  amount,
  profitOrLoss,
  profitOrLossColor,
  quantityUnit,
  link,
  refresh,
  unit,
}: AssetOrganizedPortfolioItemProps): React.ReactElement => {
  const { pushRouting } = useRouting();

  const isShowQuantity =
    quantity !== null && assetTypeKey !== AssetType['ロボアドバイザー'];

  // MEMO: 『類推中』はMONO-***で返却
  const isDataCooperation =
    assetTypeKey === AssetType['投資信託'] &&
    !isSimple(identifier) &&
    identifier !== null &&
    /^MONO/.test(identifier);

  const href = !isSimple(link) ? link : null;

  const textCcolor = isDataCooperation
    ? 'text-bluegray-300'
    : 'text-bluegray-700';

  const isManual = brokerID === ManualBrokerID.手入力口座;

  return (
    <>
      <div className={`${textCcolor}`}>
        <div
          className={`border rounded-lg p-4 mb-2 ${
            !isSimple(name) && href ? 'cursor-pointer' : ''
          }`}
          onClick={goto(pushRouting)(href)}>
          <div className="flex">
            <div className="flex-1">
              {refresh && (
                <StopAggregate
                  {...{
                    refresh,
                  }}
                />
              )}
              {isDataCooperation && (
                <>
                  <DataFetching className="mb-3" />
                </>
              )}
              <div className="flex items-center mb-1">
                <AssetTypesLabel assetType={assetTypeKey} />
                {!isSimple(identifier) && (
                  <div
                    className={`ml-2 ${isManual ? 'text-xs' : 'text-sm'} ${
                      isDataCooperation ? textCcolor : 'text-bluegray-500'
                    }`}>
                    {identifier}
                  </div>
                )}
                {!isSimple(quantity) && !isSimple(quantityUnit) && (
                  <div
                    className={`flex ml-auto text-xs leading-4.5 ${
                      isShowQuantity ? '' : 'hidden'
                    }`}>
                    <div className="mr-2">数量</div>
                    <div className="mr-1">{formatNumber(quantity, {})}</div>
                    <div>{quantityUnit}</div>
                  </div>
                )}
              </div>
              <div className="flex flex-col">
                {!isSimple(name) && (
                  <div className={`line-clamp-2 font-bold `}>{name}</div>
                )}
                {!isManual && assetTypeKey === AssetType['信用'] ? (
                  <></>
                ) : (
                  <div
                    className={`flex justify-end font-bold leading-4.5 mt-2 mb-1`}>
                    <div className="text-lg mr-1">{amount}</div>
                    <div className="text-xs">{unit ?? '円'}</div>
                  </div>
                )}
                {!isSimple(profitOrLoss) && !isSimple(profitOrLossColor) && (
                  <div className={`flex justify-end leading-4.5`}>
                    <div
                      className={`text-xs ${
                        isDataCooperation
                          ? 'text-bluegray-300'
                          : 'text-bluegray-500'
                      } mr-2`}>
                      評価損益
                    </div>
                    <div
                      className={`flex ${
                        isDataCooperation
                          ? 'text-bluegray-300'
                          : profitOrLossColor
                      }`}>
                      <div className="text-xs mr-1">{profitOrLoss}</div>
                      <div className="text-xs">{unit ?? '円'}</div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center ml-4 w-2">
              {!isSimple(name) && href && (
                <img
                  className="w-full"
                  src="/static/images/icon/icon-arrow-right.svg"
                  alt=""
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
